import React from 'react';
import { Link } from 'react-router-dom';
import { useLang } from '../contexts/LanguageContext';
import { STORE } from '../lib/i18n';

export default function Footer() {
  const { t } = useLang();
  return (
    <footer>
      <div className="wrap foot">
        <Link to="/" className="logo">
          <span className="logo-mark"><span>N</span></span>
          <span>Nathanael <span style={{ color: 'var(--blue)' }}>Appliances Corp</span></span>
        </Link>
        <div className="foot-right">
          <div>&copy; {new Date().getFullYear()} {STORE.name} · {STORE.address}</div>
          <div style={{ marginTop: 4 }}>{t('foot.tag')}</div>
          <div className="foot-socials">
            <a href={`tel:${STORE.phoneRaw}`} aria-label="Call"><i className="fa-solid fa-phone"></i></a>
            <a href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(STORE.address)}`} target="_blank" rel="noopener noreferrer" aria-label="Directions"><i className="fa-solid fa-location-dot"></i></a>
            <a href={`https://wa.me/${STORE.whatsapp}`} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp"><i className="fa-brands fa-whatsapp"></i></a>
          </div>
        </div>
      </div>
    </footer>
  );
}
